import { createStore, applyMiddleware, compose } from 'redux';
import reducer from '../reducers';
import thunkMiddleware from 'redux-thunk';
import authInterceptor from '../middleware/middleware';
import logger from 'redux-logger';

const configureStore = () => {
  if (process.env.NODE_ENV === 'production') {
    return createStore(
      reducer,
      applyMiddleware(thunkMiddleware, authInterceptor)
    );
  }

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ serialize: true })
    : compose;

  return createStore(
    reducer,
    composeEnhancers(applyMiddleware(thunkMiddleware, authInterceptor, logger))
  );
};

export default configureStore;
